import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { EnrichedNotification } from 'src/app/services/notification.service';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationActionType } from 'src/app/shared/constants/notification.constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss']
})
export class NotificationItemComponent {
  @Input() notification!: EnrichedNotification;
  @Output() notificationClick = new EventEmitter<EnrichedNotification>();
  @Output() actionClick = new EventEmitter<{ event: Event; notification: EnrichedNotification }>();

  isMenuOpen = false;

  constructor(
    public notificationService: NotificationService,
    private translateService: TranslateService
  ) { }

  canBeSnooozed(): boolean {
    return this.notification.snooze_count !== null;
  }

  @HostListener('document:click')
  closeMenu() {
    this.isMenuOpen = false;
  }

  toggleMenu(event: Event) {
    event.stopPropagation();
    this.isMenuOpen = !this.isMenuOpen;
  }

  markAsRead(event: Event) {
    event.stopPropagation();
    if (!this.notification.read_at) {
      this.notificationService.markAsRead(this.notification.id).subscribe(() => {
        this.isMenuOpen = false;
      });
    }
  }

  snoozeNotification(event: Event) {
    event.stopPropagation();
    this.notificationService.snoozeNotification(this.notification.id).subscribe(() => {
      this.isMenuOpen = false;
    });
  }

  getStatusColor(status: string): string {
    switch (status?.toLowerCase()) {
      case 'process':
        return 'text-amber-500';
      case 'cancelled':
        return 'text-red-500';
      default:
        return 'text-gray-700';
    }
  }

  getActionType(type: any): NotificationActionType {
    return type as NotificationActionType;
  }

  handleNotificationClick(): void {
    this.notificationClick.emit(this.notification);
  }

  handleActionClick(event: Event): void {
    this.actionClick.emit({ event, notification: this.notification });
  }
} 